<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        show-export
        hide-show-hide-btn
        url="repairRegistrations/page"
        multi-selection
        id-name="id">
      <template #toolbar>
        <el-button v-if="insertAuth" type="primary" @click="$refs.editPage.open()">新建</el-button>
        <el-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            :before-upload="beforeAvatarUpload"
            :disabled="disabled"
            :on-error="handlerError"
            :on-exceed="onExceed"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;margin-right: 5px;margin-left: 5px">
          <el-button :loading="importLoading" icon="el-icon-download" type="primary">DS导入</el-button>
        </el-upload>

        <el-button v-if="reportAuth" type="primary" @click="handleReport">标准报告</el-button>
        <el-button v-if="reportAuth" type="primary" @click="DsReport">蒂森报告</el-button>
      </template>
      <template #adSearch>
        <vm-search label="单据编号">
          <el-input v-model="filter.billNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="检测报告">
          <el-select
              v-model="filter.reported"
              placeholder="请选择"
              clearable>
            <el-option :value="true" label="有"/>
            <el-option :value="false" label="无"/>
          </el-select>
        </vm-search>
        <vm-search label="维修员">
          <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="维修类型">
          <el-select v-model="filter.afterSaleType" placeholder="请选择" clearable>
            <el-option value="更换"/>
            <el-option value="维修"/>
            <el-option value="回采"/>
            <el-option value="批量整改"/>
          </el-select>
        </vm-search>
        <vm-search label="售后单号" :value-width="110">
          <el-input v-model="filter.afterSaleOrderNos" type="textarea" autosize placeholder="支持输入多行"/>
        </vm-search>
        <vm-search label="质量异常单号">
          <el-input v-model.trim="filter.qualityRegistrationNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="事业部">
          <el-select v-model="filter.department" placeholder="请选择" clearable>
            <el-option value="电气"/>
            <el-option value="电机"/>
            <el-option value="运控"/>
            <el-option value="机器人"/>
            <el-option value="杭州之山"/>
            <el-option value="其他"/>
          </el-select>
        </vm-search>
        <vm-search label="客户名称">
          <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="客户单号">
          <el-input v-model.trim="filter.customerOrderNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="规格型号">
          <el-input v-model.trim="filter.model" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="部件条码" :value-width="150">
          <el-input v-model.trim="filter.partSn" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="型号">
          <el-input v-model.trim="filter.partModel" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="维修状态">
          <el-input v-model.trim="filter.repairStatus" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search-date
            label="维修日期"
            :start-time.sync="filter.startTime"
            :end-time.sync="filter.endTime"/>
        <vm-search-date
            label="预计发货日期"
            :start-time.sync="filter.expiredDeliveryDateStart"
            :end-time.sync="filter.expiredDeliveryDateEnd"/>
      </template>
      <el-table-column prop="billNo" label="单据编号" align="center" width="120px">
        <template v-slot="scope">
          <a @click="$refs.editPage.open(scope.row.id, true)">{{scope.row.billNo}}</a>
        </template>
        <template #header>
          <el-input
              v-model.trim="filter.billNo"
              placeholder="单据编号"
              clearable
              @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="afterSaleOrderNo"
          label="售后单号"
          align="center"
          width="120px"
          show-overflow-tooltip>
        <template #header>
          <el-input
              v-model.trim="filter.afterSaleOrderNo"
              placeholder="售后单号"
              clearable
              @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="customerName"
          label="客户名称"
          align="center"
          width="160px"
          show-overflow-tooltip>
        <template #header>
          <el-input
              v-model.trim="filter.customerName"
              placeholder="客户名称"
              clearable
              @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="customerOrderNo"
          width="160px"
          label="客户单号"
          align="center"
          show-overflow-tooltip>
        <template #header>
          <el-input
              v-model.trim="filter.customerOrderNo"
              placeholder="客户单号"
              clearable
              @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="creatorName"
          width="100px"
          label="维修员"
          align="center"
          show-overflow-tooltip>
        <template #header>
          <el-input
              v-model.trim="filter.creatorName"
              placeholder="维修员"
              clearable
              @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column width="220px" prop="siteDesc" label="现场描述" show-overflow-tooltip/>
      <el-table-column
          prop="afterSaleType"
          width="120px"
          label="维修类型"
          align="center"
          show-overflow-tooltip>
        <template #header>
          <el-select
              v-model="filter.afterSaleType"
              placeholder="维修类型"
              clearable
              @change="$refs.vmTable.handleSearchClick()">
            <el-option value="更换"/>
            <el-option value="维修"/>
            <el-option value="回采"/>
            <el-option value="批量整改"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
          prop="quantity"
          label="数量"
          align="center"
          width="60px"
          show-overflow-tooltip/>
      <el-table-column prop="inspectionResult" label="检测结果" align="center" show-overflow-tooltip/>
      <el-table-column prop="note" label="备注" show-overflow-tooltip/>
      <el-table-column prop="repairStatus" label="维修状态" align="center" show-overflow-tooltip>
        <template #header>
          <el-input
              v-model.trim="filter.repairStatus"
              placeholder="维修状态"
              clearable
              @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="repairFinishDate"
          label="维修完成日期"
          align="center"
          width="110px"
          show-overflow-tooltip/>
      <el-table-column
          prop="productDate"
          label="生产日期"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column
          prop="deliveryDate"
          label="发货时间"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column prop="saleTime" label="售出时长/月" align="center" show-overflow-tooltip/>
      <el-table-column prop="afterSaleExpired" label="售后过保" align="center">
        <template v-slot="scope">
          <span v-if="scope.row.afterSaleExpired === true">是</span>
          <span v-if="scope.row.afterSaleExpired === false">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="needQualitySurvey" label="需要质量报告" align="center">
        <template v-slot="scope">
          <span v-if="scope.row.needQualitySurvey === true">是</span>
          <span v-if="scope.row.needQualitySurvey === false">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="model" label="规格型号" align="center" show-overflow-tooltip>
        <template #header>
          <el-input
              v-model.trim="filter.model"
              placeholder="规格型号"
              clearable
              @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="pgCard" label="PG卡" align="center" show-overflow-tooltip/>
      <el-table-column prop="powerOnTime" label="上电时间" align="center" show-overflow-tooltip/>
      <el-table-column prop="runTime" label="运行时间" align="center" show-overflow-tooltip/>
      <el-table-column prop="radiatorTemperature" label="散热器温度" align="center" show-overflow-tooltip/>
      <el-table-column prop="faultCode" label="故障代码" align="center" show-overflow-tooltip/>
      <el-table-column prop="originProgram" label="原程序" align="center" show-overflow-tooltip/>
      <el-table-column prop="newProgram" label="新程序" align="center" show-overflow-tooltip/>
      <el-table-column prop="missingParts" label="缺件信息" align="center" show-overflow-tooltip/>
      <el-table-column prop="solution" label="处理方法" align="center" show-overflow-tooltip/>
      <el-table-column prop="faultType" label="故障模块分类" align="center" show-overflow-tooltip/>
      <el-table-column prop="problemType" label="电机问题类型" align="center" show-overflow-tooltip/>
      <el-table-column prop="causeInvestigation" label="原因分析" align="center" show-overflow-tooltip/>
      <el-table-column prop="responsibleDecision" label="责任判定" align="center" show-overflow-tooltip/>
      <el-table-column prop="reasonForCharge" label="收费原因" align="center" show-overflow-tooltip/>
      <el-table-column prop="partCosts" label="部件费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="materialCosts" label="材料费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="otherCosts" label="其他费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="laborTime" label="工时/分钟" align="center" show-overflow-tooltip/>
      <el-table-column prop="laborCosts" label="工时费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="reportCosts" label="报告费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="totalCosts" label="总费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="note" label="备注" show-overflow-tooltip/>
      <el-table-column prop="repairStatus" label="维修状态" align="center" show-overflow-tooltip>
        <template #header>
          <el-input
              v-model.trim="filter.repairStatus"
              placeholder="维修状态"
              clearable
              @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="repairDate"
          label="维修日期"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column
          prop="expiredDeliveryDate"
          label="预计发货日期"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column prop="attachmentNote" label="附件备注" show-overflow-tooltip/>
      <el-table-column prop="createTime" label="创建时间" align="center" width="140px"/>
      <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="120px">
        <template v-slot="scope">
          <el-button v-if="editAuth" type="success" @click="$refs.editPage.open(scope.row.id)">编辑</el-button>
          <el-button v-if="deleteAuth" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <repair-registration-edit ref="editPage" @save-success="getList(-1)"/>
    <repair-registration-report ref="reportPage" @save-success="getList(-1)"/>
    <repair-registration-report-d-s ref="reportPageDS" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/v2/VmTable";
  import VmSearch from "@/components/v2/VmSearch";
  import RepairRegistrationEdit from "@/views/maintenanceManage/RepairRegistration/RepairRegistrationEdit.vue";
  import VmSearchDate from "@/components/VmSearchDate.vue";
  import loginUtil from "@/util/loginUtil";
  import RepairRegistrationReport from "@/views/maintenanceManage/RepairRegistration/RepairRegistrationReport.vue";
  import RepairRegistrationReportDS from "@/views/maintenanceManage/RepairRegistration/RepairRegistrationReportDS";

  export default {
    name: "RepairRegistrationList",
    components: {
      RepairRegistrationReportDS,
      RepairRegistrationReport, VmSearchDate, VmTable, VmSearch, RepairRegistrationEdit,
    },
    data() {
      return {
        userId: loginUtil.getUserId(),
        editAuth: true,
        insertAuth: true,
        deleteAuth: true,
        reportAuth: true,
        exportLoading: false,
        importLoading: false,
        dialogVisible: false,
        disabled: false,
        uploadUrl: window.config.basicServerHttpUrl + "repairRegistrations/importExcel",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        filter: {
          billNo: "",
          status: "",
          creatorName: "",
          afterSaleType: "",
          afterSaleOrderNo: "",
          afterSaleOrderNos: "",
          qualityRegistrationNo: "",
          department: "",
          demandNode: "",
          partType: "",
          customerName: "",
          outCustomerName: "",
          customerOrderNo: "",
          demandSn: "",
          demandMaterialNo: "",
          receiveSn: "",
          receiveMaterialNo: "",
          model: "",
          moduleBranding: "",
          originPartSn: "",
          partSn: "",
          partModel: "",
          componentMaterialNo: "",
          repairStatus: "",
          startTime: "",
          endTime: "",
          expiredDeliveryDateStart: "",
          expiredDeliveryDateEnd: "",
          newMachineSn: "",
          newMaterialNo: "",
          reported: "",
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleDelete(row) {
        this.$confirm(`确定删除单据 ${row.billNo} 吗?`, "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "repairRegistrations", row.id).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
      handleExport() {
        this.$confirm("确定导出吗?", "提示", {type: "warning"}).then(() => {
          this.exportLoading = true;
          this.$http.exportExcelByHeader("basic", "repairRegistrations/export", this.filter, "post")
              .finally(() => {
                this.exportLoading = false;
              });
        });
      },
      handleReport() {
        if (this.$refs.vmTable.selection.length === 0 || this.$refs.vmTable.selection.length > 1) {
          this.$message.error("请选择至多一条记录");
          return;
        }
        if (this.$refs.vmTable.selection[0].reported) {
          this.$refs.reportPage.open(this.$refs.vmTable.selection[0], true, true);
        } else {
          this.$refs.reportPage.open(this.$refs.vmTable.selection[0], true, false);
        }
      },
      DsReport() {
        if (this.$refs.vmTable.selection.length === 0 || this.$refs.vmTable.selection.length > 1) {
          this.$message.error("请选择至多一条记录");
          return;
        }
        if (this.$refs.vmTable.selection[0].reported) {
          this.$refs.reportPageDS.open(this.$refs.vmTable.selection[0], true, true);
        } else {
          this.$refs.reportPageDS.open(this.$refs.vmTable.selection[0], true, false);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
